module.exports = __webpack_public_path__ + "img/warzone.3b4895a2.png";